import { Checkbox } from '@/components/ui/checkbox'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { CheckboxFilterCell } from 'components/Filter/FilterCell'

import { TickmillCompanyFilterCell } from '../CountriesFilters'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const tradingAccountsColumns: GridColumn[] = [
  {
    title: 'Tickmill Company',
    field: 'tickmillCompany.name',
    filterCell: TickmillCompanyFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Country',
    field: 'country.name',
    show: true,
    sortable: false,
  },
  {
    title: 'Welcome Account Allowed',
    field: 'welcomeAccountAllowed',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps) => {
      return (
        <td className='text-center align-middle'>
          <div className='flex justify-center'>
            <Checkbox checked={props.dataItem?.welcomeAccountAllowed} size='sm' disabled readOnly />
          </div>
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Demo Account Allowed',
    field: 'demoAccountAllowed',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps) => {
      return (
        <td className='text-center align-middle'>
          <div className='flex justify-center'>
            <Checkbox checked={props.dataItem?.demoAccountAllowed} size='sm' disabled readOnly />
          </div>
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Account Auto Created',
    field: 'accountAutoCreated',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps) => {
      return (
        <td className='text-center align-middle'>
          <div className='flex items-center justify-center gap-[5px] h-full'>
            <Checkbox checked={props.dataItem?.accountAutoCreated} size='sm' disabled readOnly />

            <span>{props.dataItem?.platformType?.name}</span>
          </div>
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  // {
  //   title: 'Account Auto Created',
  //   field: 'accountAutoCreated',
  //   filterCell: CheckboxFilterCell,
  //   cell: (props: GridCellProps) => {
  //     return (
  //       <td className='text-center align-middle'>
  //         <div className='flex items-center justify-center gap-[5px] h-full'>
  //           <Checkbox checked={props.dataItem?.accountAutoCreated} size='sm' disabled readOnly />
  //
  //           <span>{props.dataItem?.platformType?.name}</span>
  //         </div>
  //       </td>
  //     )
  //   },
  //   show: true,
  // },
]

export default tradingAccountsColumns
